import { CompanyHouseAPI } from "@/api/company-house";

const api = new CompanyHouseAPI();

export const useCompanyHouseApi = () => ({ api });
